export var calculateInputSelection = function (element) {
    var inputWidth = element.getBoundingClientRect().width || 0;
    var start = element.selectionStart;
    var cursorCoords = {
        top: 30,
        left: Math.min(7 * (start + 1), inputWidth)
    };
    var selection = { start: start, end: element.selectionEnd, cursorCoords: cursorCoords };
    return selection;
};
export var calculateTextAreaSelection = function (element, content) {
    var textAreaWidth = element.getBoundingClientRect().width || 0;
    var textAreaHeight = element.getBoundingClientRect().height || 0;
    var start = element.selectionStart;
    var linesUntilCursor = content.substr(0, start).split('');
    var cursorLine = linesUntilCursor.length;
    var cursorLineLength = cursorLine ? linesUntilCursor[cursorLine - 1].length : 0;
    var cursorCoords = {
        top: Math.min(25 * cursorLine, textAreaHeight),
        left: Math.min(7 * (cursorLineLength + 1), textAreaWidth)
    };
    var selection = { start: start, end: element.selectionEnd, cursorCoords: cursorCoords };
    return selection;
};
//# sourceMappingURL=user-input-commons.js.map